import { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { actionGetCriteriasList } from "../../../redux/action/userSingleReport/actionUserSingleReport";
import { AppDispatch } from "../../../redux/reducer/store";

import Select from "../../custom/select/select";

import styles from "../headerBtn.module.scss";
import { IReportCriteriasOptions } from "../../../types/reportsInterfaces";

interface IReviewStatusOptions {
  setReviewReasonError: (el: string) => void;
  setSelectedOption: (el: string) => void;
  setSelectedReason: (el: string) => void;
  reviewReasonError: string;
}

const statusOptions = [
  { value: "NotChecked", label: "Не проверен" },
  { value: "Revision", label: "Доработка" },
  { value: "Rejected", label: "Отклонен" },
  { value: "Approved", label: "Утвержден" },
];

const UpdateReviewStatusSection: FC<IReviewStatusOptions> = ({
  setReviewReasonError,
  setSelectedOption,
  setSelectedReason,
  reviewReasonError,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const { reportsInputValues } = useSelector(
    (state: any) => state.userReports.userReports
  );
  const { list } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );

  useEffect(() => {
    dispatch(actionGetCriteriasList(reportsInputValues.contracts[0]));
  }, [dispatch, reportsInputValues.contracts]);

  const handleSelecteChange = (event: { value: string, label: string }) => {
    setSelectedOption(event.value);
  };

  const handleReasonSelectChange = (event: { value: string, label: string }) => {
    setSelectedReason(event.value);
    setReviewReasonError("");
  };

  return (
    <div className={styles.block__info}>
      <div className={styles.limit__block}>
        <span>Статус:</span>
        <Select
          className={styles.photo__select}
          defaultValue={statusOptions[0]}
          propsChange={(event: { value: string, label: string }) => handleSelecteChange(event)}
          options={statusOptions}
        />
      </div>
      <div className={styles.limit__block}>
        <span>Причина:</span>
        <div className={styles.error__reason_block}>
          <Select
            className={
              reviewReasonError
                ? styles.error__reason_select
                : styles.photo__select
            }
            propsChange={(event: { value: string, label: string }) => handleReasonSelectChange(event)}
            placeholder="Выберите причину"
            options={
              list &&
              list?.map((item: IReportCriteriasOptions) => {
                return {
                  value: item?.reason?.id,
                  label: item?.reason?.name,
                };
              })
            }
          />
          {reviewReasonError && (
            <span className={styles.error}>{reviewReasonError}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpdateReviewStatusSection;
